var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info',[_c('div',{domProps:{"innerHTML":_vm._s(
      _vm.$t('RESELLER_PROGRAM_DESC_9', {
        staffSignUpLink: 'https://a.appdb.to/acp.php?action=signup',
        paymentForRef: _vm.pay_for_ref,
        paymentPlusForRef: _vm.plus_pay_for_ref,
        paidToRefs: _vm.paidToRefs,
        paidToStaff: _vm.paid_staff_funds,

        appRequestsLink: '/requests',
        spentOnRequests: _vm.requests_paid_funds,
      })
    )}}),_c('br'),_c('br'),_c('br'),_c('br'),_c('div',{domProps:{"innerHTML":_vm._s(
      _vm.$t('RESELLER_PROGRAM_DESC_1', {
        paidToResellers: _vm.paidToResellers,
        privacyIconLink: 'https://oldstatic.appdb.to/img/privacy-icon@2x.png',
      })
    )}}),_c('div',{domProps:{"innerHTML":_vm._s(
      _vm.$t('RESELLER_PROGRAM_DESC_2', {
        pricePerDevice: _vm.price_per_device,
      })
    )}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('RESELLER_PROGRAM_DESC_3'))}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('RESELLER_PROGRAM_DESC_4'))}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('CREATE_STAFF_ACCOUNT_TO_CONTINUE', {
          staffSignUpLink: 'https://a.appdb.to/acp.php?action=signup'}))}}),_c('template',{slot:"sidebar"},[_c('html-with-links',{attrs:{"html":_vm.$t('RESELLER_PROGRAM_SIDEBAR', {
          staffSignUpLink: 'https://a.appdb.to/acp.php?action=signup',
          refProgramLink: '#ref_program',
          devAccountProgramLink: '#dev_account_program',
          staffSupportLink: '#staff_support',
          requestsFundLink: '#requests_fund',
        })}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }